import { render, staticRenderFns } from "./laboratories.vue?vue&type=template&id=e01ecfce&scoped=true&"
import script from "./laboratories.vue?vue&type=script&lang=js&"
export * from "./laboratories.vue?vue&type=script&lang=js&"
import style0 from "./laboratories.vue?vue&type=style&index=0&id=e01ecfce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01ecfce",
  null
  
)

export default component.exports